// Show Tax Exempted Orders in Selected Month
<template lang="pug">
v-dialog(v-model="dialog", width="700")
  template(v-slot:activator="{ on }")
    v-btn.text-capitalize(
      @click="load()",
      color="secondary",
      outlined,
      small,
      v-on="on"
    ) Tax Exempt Orders
  v-card
    v-card-title
    OrderTable(:loading="loading") 
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import OrderTable from "@/components/Order/Table/index";

export default {
  name: "NEOrders",
  components: { OrderTable },
  props: ["range"],
  data: () => ({
    loading: false,
    dialog: false,
  }),
  computed: { ...mapGetters(["biz"]) },
  methods: {
    ...mapActions(["setOrders"]),
    async load() {
      if (!this.range || !this.biz) return;
      const params = {
        criteria: {
          "seller.id": this.biz._id,
          needed: { $gte: this.range.begin, $lt: this.range.end },
          status: { $gte: 0 },
          te: true,
        },
        select: "orderer needed created orderNumber status payment",
      };
      this.loading = true;
      const res = await this.axios.post("/orders/list", params);
      this.setOrders(res.data);
      this.loading = false;
    },
  },
};
</script>
